import { type SanitizedResult } from '@amzn/bf-gql'
import { imageFieldsFrag } from './imageFieldsFrag'
import { gql } from './gql'

// language=GraphQL
export const interludeFieldsFrag = gql(
    `
        fragment interludeFields on Interlude @_unmask {
            __typename
            id
            name
            image {
                ...imageFields
            }
            playbackInformation {
                audioUrl
            }
        }
    `,
    [imageFieldsFrag]
)

// Not a schema `PlayableEntity`: the queue plays an interlude off its audio url, so it has no uri or playParams.
export type InterludeFields = SanitizedResult<typeof interludeFieldsFrag> & {
    readonly uri?: undefined
    readonly playParams?: undefined
}
